import ApisServiceAuth from '@api/ApisServiceAuth'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'


export function getDetailHeThong(id: string) {
  try {
    return ApisServiceAuth.get('/hethong/' + id + '/get-chitiet-hethong')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListHeThong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceAuth.get('/hethong/filter-hethong', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function changeHeThong(projectId: number) {
  return ApisServiceAuth.put('/hethong/' + projectId + '/doi-hethong')
} 